import '../scss/style.scss';
import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Autoplay, EffectFade, EffectCube, EffectCoverflow, EffectFlip } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
	const galleries = document.querySelectorAll('.hero-gallery');

	galleries.forEach((gallery) => {
		const direction = gallery.closest('.wp-block-column:first-child:has(.hero-gallery)') ? 'rtl' : 'ltr';

		const swiper = new Swiper(gallery, {
			modules: [Navigation, A11y, Autoplay],
			slidesPerView: 2,
			breakpoints: {
				// when window width is >= 782px@
				782: {
					slidesPerView: 3,
				}
			},
			spaceBetween: 20,
			loop: true,
			speed: 2000,
			allowTouchMove: false,
			autoplay: {
				delay: 2000,
				pauseOnMouseEnter: true,
				reverseDirection: direction === 'rtl',
			},
			direction: 'horizontal',
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	});

	// Handle dismissible alerts
	const dismissButtons = document.querySelectorAll('.alert-dismiss');

	dismissButtons.forEach((button) => {
		button.addEventListener('click', function() {
			const alert = this.closest('.alert');
			if (alert) {
				// Add fade out animation
				alert.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';
				alert.style.opacity = '0';
				alert.style.transform = 'translateY(-10px)';

				// Remove from DOM after animation
				setTimeout(() => {
					alert.remove();
				}, 300);
			}
		});
	});
});
